<template>
  <footer class="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="py-6">
        <!-- Main footer content -->
        

        <!-- Bottom section -->
        
          <div class="flex flex-col md:flex-row justify-between items-center">
            <div class="flex items-center space-x-6 mb-4 md:mb-0">
              <a 
                href="#" 
                class="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 text-sm transition-colors"
              >
                Política de Privacidade
              </a>
              <a 
                href="#" 
                class="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 text-sm transition-colors"
              >
                Termos de Uso
              </a>
              <a 
                href="#" 
                class="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 text-sm transition-colors"
              >
                Cookies
              </a>
            </div>
            <div class="text-gray-600 dark:text-gray-400 text-sm">
              © {{ currentYear }} Sistema Escolar. Todos os direitos reservados.
            </div>
          </div>
        
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

// Get current year for copyright
const currentYear = computed(() => new Date().getFullYear())
</script>